import React, { useEffect, useState,useCallback } from "react";
import GridTable from "./UI/base/GridTable/components/GridTable";
import { config } from "../config";
import { axiosRun } from "../utils/axiosWrap";
import CircularProgress from "@mui/material/CircularProgress";
import Box from '@mui/material/Box';
import {shallowEqual, useSelector} from "react-redux";


export const ApplicantsList = () => {
    const [isLoad, setIsLoad] = useState(true);
    const [countries, setCountries] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [columns, setColumns] = useState([]);
    const [columnsForQuick, setColumnsForQuick] = useState([]);
    const [faculties, setFaculties] = useState([]);
    const [facultiesGroupsList, setFacultiesGroupsList] = useState([]);
    const [degreesList, setDegreesList ] = useState([]);
    const roles = useSelector((state) => state.users.user, shallowEqual).user.roles;

    useEffect(() => {

        const loadAllReq = async () => {
                const faculties = await axiosRun(
                    roles!=='ADMIN_GROUP_LEAD'?config.apiLinks.getFacultiesList:config.apiLinks.getFacultiesListGroupLead,
                    'GET'
                );
                setFaculties(faculties);

                const _facultiesGroupsList = await axiosRun(
                    roles!=='ADMIN_GROUP_LEAD'?config.apiLinks.getFacultiesgroupList:config.apiLinks.getFacultiesgroupListGroupLead,
                    'GET'
                );
                setFacultiesGroupsList(_facultiesGroupsList);

                const _degreesList = await axiosRun(config.apiLinks.getDegreesList, 'GET');
                setDegreesList(_degreesList.map(item => { return {...item, 'label':item.name, 'value': item.id} }));
                setIsLoad(false);
        };
        if (isLoad === true) {
                loadAllReq();
        }
    }, [isLoad])

    useEffect(() => {
        if (!isLoad && Object.keys(faculties).length > 0) {
            const columns = [
                { id: 'lastName', numeric: false, disablePadding: false, label: 'Прізвище', isLinkItem: true },
                { id: 'firstName', numeric: false, disablePadding: true, label: "Ім'я", isLinkItem: true },
                { id: 'middleName', numeric: false, disablePadding: false, label: 'По батькові', isLinkItem: true },
                { id: 'ipnNumber', numeric: true, disablePadding: false, label: "ІПН", isLinkItem: true },
                { id: 'status', numeric: true,  type: 'bool', disablePadding: false, label: "Опрацьовано?", isLinkItem: true },
            ];
            const columnsFormQuick = [
            ];
            setColumns(columns);
            setColumnsForQuick(columnsFormQuick)
        }
    }, [isLoad, countries, documents, faculties])

    const triggerLinks = {
        editLinkSave: config.apiLinks.addOrEditStudent,
        createLinkSave: config.apiLinks.addOrEditStudent,
        refreshLink: '#',
        linkItem: '/administration/applicant/item/%itemId%',
        deleteLink: '#',
        redirectAfterAdd: '#'
    }
    return <>
        {!isLoad && roles ? <GridTable
            linkGetData={config.apiLinks.getApplicantList}
            isLazy={false}
            columns={columns}
            triggerLinks={triggerLinks}
            columnsFormQuick={columnsForQuick}
            tableHeaderText={"Запити абітурієнтів"}
            isAddLink={false}
            quickViewNotAllowed={true}
            rows4page={10}
            filtersList={[
                { name: 'firstNameHash', label: "Ім`я", type: 'text' },
                { name: 'lastNameHash', label: "Прізвище", type: 'text' },
                { name: 'middleNameHash', label: 'По батькові', type: 'text' },
                { name: 'ipnNumberHash', label: 'IПН', type: 'text' },
                { name: 'status', label: 'опрацьовано?', type: 'select', default: -1, options: [{value: -1,label: 'Не вибрано'},{value:0, label: 'Ні'},{value:1, label: 'Так'}]},

                { name: "faculty_sp_spec_group", label: "Факультет/спеціальність/спеціалізація/", type: 'autocomplete', options: facultiesGroupsList }
            ]}
        /> : <Box component="div" sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: '#ffffffab', zIndex: 9 }}>
            <CircularProgress color="success" size={70} sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
        </Box>}
    </>

}